// Shared "stat tile" used for the small uppercase-label / big-bold-number
// summary cards at the top of dashboard-style pages (Reporting, Dashboard,
// Invoices, My Tasks, Daily Standup, Burndown, ...). Centralising it here
// keeps that look — font, weight, tracking, surface, colour — consistent
// instead of every page hand-rolling its own slightly different version.

// Recharts and a few other consumers need this same surface treatment for
// non-tile cards, so it's exported for reuse rather than kept private.
export const SURFACE = "bg-white dark:bg-[#161c26] border border-slate-200 dark:border-white/[0.08] shadow-sm dark:shadow-lg dark:shadow-black/20";

export const STAT_COLOUR = {
  default: { text: "text-foreground", accent: "bg-slate-300 dark:bg-white/15" },
  success: { text: "text-emerald-600 dark:text-emerald-400", accent: "bg-emerald-500 dark:bg-[#34D399]" },
  warning: { text: "text-amber-600 dark:text-amber-400", accent: "bg-amber-500 dark:bg-[#FBBF24]" },
  danger: { text: "text-rose-600 dark:text-rose-400", accent: "bg-rose-500 dark:bg-[#FB4B8F]" },
};

const StatTile = ({ label, value, unit, sub, colour = "default", icon: Icon, testid }) => {
  const c = STAT_COLOUR[colour] || STAT_COLOUR.default;
  return (
    <div className={`relative overflow-hidden ${SURFACE} rounded-xl p-5`} data-testid={testid}>
      <div className={`absolute inset-x-0 top-0 h-[3px] ${c.accent}`} />
      <div className="flex items-center justify-between gap-2">
        <div className="text-[11px] font-semibold uppercase tracking-[0.2em] text-muted-foreground">{label}</div>
        {Icon && <Icon className="w-4 h-4 text-muted-foreground/60" />}
      </div>
      <div className="flex items-baseline gap-2 mt-2">
        <span className={`font-mono font-bold text-3xl tracking-tight ${c.text}`}>{value ?? "—"}</span>
        {unit && <span className="text-sm text-muted-foreground">{unit}</span>}
      </div>
      {sub && <div className="text-xs text-muted-foreground mt-1">{sub}</div>}
    </div>
  );
};

export default StatTile;
